/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Show_LabelInputs */

const en_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show key`)
};

const fr_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher la clé`)
};

const de_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel anzeigen`)
};

const it_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra chiave`)
};

const ru_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать ключ`)
};

const es_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar clave`)
};

const zh_cn2_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示密钥`)
};

const ja_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーを表示`)
};

const hi_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी दिखाएँ`)
};

const pt_pt2_options_api_keys_show_label = /** @type {(inputs: Options_Api_Keys_Show_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar chave`)
};

/**
* | output |
* | --- |
* | "Show key" |
*
* @param {Options_Api_Keys_Show_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_show_label = /** @type {((inputs?: Options_Api_Keys_Show_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Show_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_show_label(inputs)
	if (locale === "de") return de_options_api_keys_show_label(inputs)
	if (locale === "it") return it_options_api_keys_show_label(inputs)
	if (locale === "ru") return ru_options_api_keys_show_label(inputs)
	if (locale === "es") return es_options_api_keys_show_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_show_label(inputs)
	if (locale === "ja") return ja_options_api_keys_show_label(inputs)
	if (locale === "hi") return hi_options_api_keys_show_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_show_label(inputs)
	return en_options_api_keys_show_label(inputs)
});